import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import * as React from "react";

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onAbort?: () => void;
  text: string | JSX.Element;
  confirmButtonText?: string;
  abortButtonText?: string;
}

class ConfirmationDialog extends React.Component<Props> {
  static defaultProps = {
    confirmButtonText: "Ja",
    abortButtonText: "Nein",
  };

  private handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      event.stopPropagation();
      this.props.onConfirm();
    } else if (event.key === "Escape") {
      event.stopPropagation();
      this.props.onClose();
    }
  };

  public render() {
    return (
      <>
        <Dialog
          open={this.props.open}
          onClose={this.props.onClose}
          onKeyDown={this.handleKeyDown}
        >
          <DialogContent>
            <DialogContentText>{this.props.text}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.onAbort} color="primary">
              {this.props.abortButtonText}
            </Button>
            <Button onClick={this.props.onConfirm} color="primary">
              {this.props.confirmButtonText}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

export default ConfirmationDialog;



// WEBPACK FOOTER //
// ./src/components/generic/ConfirmationDialog.tsx